import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { formatNumber } from '../../../../common/utils/common.utils';
import { IVendorLedger } from '../types/vendorLedgerTypes';
import { getLedgerRefLink } from './ledgerUtils';

export const VendorLedgerUtils = (
  queryData: {
    isTrash: '0' | '1';
    current: number;
    pageSize: number;
  },
  isForPrint?: boolean
): ColumnsType<IVendorLedger> => {
  return [
    {
      title: 'SL.',
      align: 'center',
      fixed: 'left',
      width: 40,
      render: (_, data, index) => (
        <>{((queryData.current || 1) - 1) * (queryData.pageSize || 20) + 1 + index}</>
      ),
    },
    {
      title: 'Trxn Date',
      key: 'vtrxn_created_at',
      fixed: 'left',
      render: (_, record) => {
        return `${dayjs(record.vtrxn_created_at).format('DD-MM-YYYY')}`;
      },
      align: 'center',
      width: 100,
    },

    {
      title: 'Voucher',
      dataIndex: 'vtrxn_voucher',
      hidden: isForPrint,
      render: (filed, rec) => {
        const link = getLedgerRefLink(rec.vtrxn_voucher, rec.ref_id);
        return link ? (
          <Link target='_blank' to={link}>
            {filed}
          </Link>
        ) : (
          <span>{filed}</span>
        );
      },
      key: 'vtrxn_voucher',
    },

    {
      title: 'Client Name',
      render: (record) => (
        <span style={{ fontWeight: 'bold', color: '#DB2777' }}>{record?.client_name}</span>
      ),
    },

    {
      title: 'Ticket No',
      dataIndex: 'vtrxn_airticket_no',
      key: 'vtrxn_airticket_no',
      render: (_, data) => (
        <span>
          {data?.vtrxn_airticket_no?.split(',').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </span>
      ),
    },
    {
      title: 'PNR',
      dataIndex: 'vtrxn_pnr',
      key: 'vtrxn_pnr',
      render: (_, data) => (
        <span>
          {data?.vtrxn_pnr?.split(',').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </span>
      ),
    },
    {
      title: 'Pax Name',
      dataIndex: 'vtrxn_pax',
      key: 'vtrxn_pax',
      render: (_, data) => (
        <span>
          {data?.vtrxn_pax?.split(',').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </span>
      ),
    },
    {
      title: 'Routes',
      dataIndex: 'vtrxn_route',
      key: 'vtrxn_route',
      align: 'center',
      width: 100,
    },

    {
      title: 'Pay Method',
      dataIndex: 'vtrxn_pay_type',
      key: 'vtrxn_pay_type',
      align: 'center',
    },

    {
      title: 'Note',
      dataIndex: 'vtrxn_note',
      key: 'vtrxn_note',
      width: 250,
      render: (column, data) => (
        <span>
          {data?.vtrxn_note?.split('\n')?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </span>
      ),
    },

    {
      title: 'Particulars',
      dataIndex: 'trxntype_name',
      key: 'trxntype_name',
      width: 170,
    },
    {
      title: 'Debit',
      key: 'vtrxn_amount',
      align: 'right',
      render: (_, data) => (
        <>
          {data.vtrxn_type === 'DEBIT' ? (
            <p>
              <span style={{ color: 'red' }}>{formatNumber(data.vtrxn_amount)}</span>
            </p>
          ) : (
            '0.00'
          )}
        </>
      ),
    },
    {
      title: 'Credit',
      key: 'vtrxn_amount',
      align: 'right',
      render: (_, data) => (
        <>
          {data.vtrxn_type === 'CREDIT' ? (
            <p>
              <span style={{ color: 'green' }}>{formatNumber(data.vtrxn_amount)}</span>
            </p>
          ) : (
            '0.00'
          )}
        </>
      ),
    },
    {
      title: 'Balance',
      dataIndex: 'vtrxn_lbalance',
      key: 'vtrxn_lbalance',
      align: 'right',
      sorter: (a, b) => Number(a.vtrxn_lbalance) - Number(b.vtrxn_lbalance),
      render: (amount) => {
        return isForPrint ? (
          <span style={{ color: parseInt(amount) < 0 ? 'green' : 'red' }}>
            {Number(amount) === 0 ? '' : Number(amount) > 0 ? '' : '-'}
            {formatNumber(amount)}
          </span>
        ) : (
          <span style={{ color: parseInt(amount) < 0 ? 'green' : 'red' }}>
            {formatNumber(amount)}
          </span>
        );
      },
    },

    {
      title: 'Created Date',
      key: 'vtrxn_created_date',
      render: (_, record) => {
        return `${dayjs(record.vtrxn_created_date).format('DD-MM-YYYY')}`;
      },
      align: 'center',
      width: 100,
    },
  ];
};
